import React from 'react';
import {SurveyContextProvider} from '../../context/surveyContext';
import {ReportContextProvider} from '../../context/reportContext';
import Result from '../../components/ElectionMode/Result';

const ElectionMode = () => {
    return (
        <SurveyContextProvider>
            <ReportContextProvider>
                <Result/>
            </ReportContextProvider>
        </SurveyContextProvider>
    );
};

export default ElectionMode;
